import React from 'react';
import type { LoginFormHelpers, LoginFormValues } from 'components/organisms';
import { LoginForm } from 'components/organisms';
import { AuthenticationTemplate } from 'components/templates';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';

export interface LoginPageProps {
    initialLoginFormValues: LoginFormValues;
    onLoginFormSubmit: (values: LoginFormValues, helpers: LoginFormHelpers) => void;
}

const LoginPage: React.FC<LoginPageProps> = props => (
    <AuthenticationTemplate>
        <div className='m-3'>
            <img src={process.env.REACT_APP_LOGO} style={{ marginLeft: 15, marginTop:15 }} width={"40px"} alt='logo' />
        </div>
        <Container>
            <Row className="justify-content-center">
                <Col lg="5">
                    <Card className="shadow-lg border-0 mt-5">
                        <CardHeader className='border-0 bg-white'>
                            <h3 className="text-center font-weight-light my-4" style={{fontSize: '18px'}}>ログイン</h3>
                        </CardHeader>
                        <CardBody>
                            <LoginForm
                                initialValues={props.initialLoginFormValues}
                                onSubmit={props.onLoginFormSubmit}
                            />
                        </CardBody>
                        <CardFooter className="text-center py-3 border-0 bg-white">
                            <Link className="small" to="/forgot-password">
                                パスワードの再設定
                            </Link>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>
        </Container>
    </AuthenticationTemplate>
);

export default LoginPage;
